export const openOrderSidebar = {
  methods: {
    openOrderSidebar(id, edit, tab) {
      if (id && !this.$route.query.hasOwnProperty('order')) {
        const query = (edit) ? {...this.$route.query, order: id, 'edit-order': (edit.edit || edit)} 
                    : (tab) ? {...this.$route.query, order: id, 'tab-order': (tab.tab || tab)} 
                    : {...this.$route.query, order: id};

        this.$router.push({
          query: query
        });
        setTimeout(() => {
          this.$root.$emit('bv::toggle::collapse', 'sidebar-right-order');
        }, 0)
      } else if (id && this.$route.query.hasOwnProperty('order')) {
        const query = (edit) ? {order: id, 'edit-order': (edit.edit || edit)} 
                    : (tab) ? {order: id, 'tab-order': (tab.tab || tab)} 
                    : {order: id};

        let routeData = this.$router.resolve({
          path: '/orders',
          query: query
        });
        window.open(routeData.href, '_blank');
      } else if (!id && tab) {
        this.$router.push({
          query: {
            ...this.$route.query,
            'tab-order': tab.tab
          }
        });
      }
    },
  }
}